import PropTypes from 'prop-types';
import React from 'react';
import createSvgIcon from '../createSvgIcon';
import { defaultProps, propTypes } from '../props';
import useColor from '../useColor';

const LinkedIn = ({
  color
}) => {
  const iconColor = useColor(color);
  const Icon = createSvgIcon({
    title: 'linkedin',
    width: '32px',
    height: '32px',
    viewBox: '0 0 24 24',
    content: /*#__PURE__*/React.createElement("path", {
      d: "M21.79,21.79h-4V15.46c0-1.54,0-3.46-2.11-3.46s-2.41,1.64-2.41,3.36v6.43H9.12v-13h3.94v1.82h.09A4.23,4.23,0,0,1,17,8.45c4.13,0,4.9,2.69,4.9,6.23ZM4.5,6.92A2.36,2.36,0,0,1,2.1,4.61h0a2.41,2.41,0,0,1,2.3-2.4A2.42,2.42,0,0,1,6.82,4.5h0A2.25,2.25,0,0,1,4.74,6.91ZM6.62,21.79H2.5v-13h4V21.79Z",
      fill: iconColor
    })
  });
  return /*#__PURE__*/React.createElement(Icon, null);
};

LinkedIn.propTypes = { ...propTypes,
  color: PropTypes.oneOf(['black', 'white', 'blue'])
};
LinkedIn.defaultProps = { ...defaultProps
};
export default LinkedIn;